/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./CalenderDashboard.scss";
import useCalendarDashboard from "./useCalendarDashboard";
import Events from "./tabs/Events";
import ScheduledEvents from "./tabs/ScheduledEvents";
import Availability from "../Availability";

export default (props) => {
  const {
    eventsLoading,
    pastEventsLoading,
    upcomingEventsLoading,
    calendarPastInterviews,
    calendarUpcomingInterviews,
    calendarEventLists,
    calendarEventListsData,
    activeTab,
    eventsRef,
    pastEventsRef,
    upcomingEventsRef,
    onEventDeleteClick,
    onEventEditClick,
    onEventLinkClick,
    onEventCopyLinkClick,
    onJoinHMSClick,
    onViewProfile,
    onScrollEvents,
    onScrollPastEvents,
    onScrollUpcomingEvents,
    onCreateEventClick,
  } = useCalendarDashboard(props);


  return (
    <div className="calender-dashboard-wrapper">
      <div className="calender-dashboard h-100">
        <div className="container">
          {activeTab && (
            <Tabs defaultActiveKey={activeTab} className="upper-tabs mb-3">
              <Tab eventKey="Availability" title="Availability">
                <div className="mt-4">
                  <Availability />
                </div>
              </Tab>
              <Tab eventKey="Events" title="Events">
                <Events
                  eventsLoading={eventsLoading}
                  calendarEventLists={calendarEventLists}
                  onScrollEvents={onScrollEvents}
                  eventsRef={eventsRef}
                  onEventDeleteClick={onEventDeleteClick}
                  onEventLinkClick={onEventLinkClick}
                  onEventEditClick={onEventEditClick}
                  onEventCopyLinkClick={onEventCopyLinkClick}
                  calendarEventListsData={calendarEventListsData}
                  onCreateEventClick={onCreateEventClick}
                />
              </Tab>
              <Tab eventKey="ScheduledEvents" title="Scheduled Events">
                <ScheduledEvents
                  upcomingEventsLoading={upcomingEventsLoading}
                  pastEventsLoading={pastEventsLoading}
                  calendarUpcomingInterviews={calendarUpcomingInterviews}
                  calendarPastInterviews={calendarPastInterviews}
                  onScrollPastEvents={onScrollPastEvents}
                  onScrollUpcomingEvents={onScrollUpcomingEvents}
                  upcomingEventsRef={upcomingEventsRef}
                  pastEventsRef={pastEventsRef}
                  onJoinHMSClick={onJoinHMSClick}
                  onViewProfile={onViewProfile}
                  onCreateEventClick={onCreateEventClick}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    </div>
  );
};
